'use client';

import { useEffect, useState } from 'react';
import Image, { ImageProps } from 'next/image';

const ClientImage = (props: ImageProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Placeholder div preserves layout and prevents hydration error
  if (!isClient) {
    return <div style={{ width: props.width, height: props.height }} />;
  }

  return <Image {...props} />;
};

export default ClientImage;
